import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useProducts = (term = '') => useQuery({ queryKey: ['products', term], queryFn: async () => {
    const callback = await API.get(`/products?term=${term}`)
    return callback?.data
}})

export default useProducts